export default __webpack_public_path__ + "static/media/Aura-Egg__59.be9daf6b.png";